import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Portal crash caught by ErrorBoundary:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        className="min-h-screen flex items-center justify-center p-6 bg-background"
        data-testid="error-boundary-fallback"
      >
        <div className="max-w-md w-full text-center bg-card border border-border rounded-2xl shadow-lg p-8">
          <div className="inline-flex p-3 rounded-full bg-[hsl(var(--warning-light))] mb-5">
            <AlertTriangle className="h-8 w-8 text-[hsl(var(--warning))]" />
          </div>
          <h1 className="text-2xl font-bold mb-3" style={{ fontFamily: 'Fredoka, sans-serif' }}>
            Something went wrong
          </h1>
          <p className="text-muted-foreground text-sm mb-6">
            Your details have not been lost — nothing was submitted. Please reload and try again. If
            this keeps happening, contact us at admin@puresouls.com.au and we will take the request
            over the phone.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-xl font-semibold text-sm hover:opacity-90 transition-opacity"
            data-testid="error-boundary-reload-btn"
          >
            <RefreshCw className="h-4 w-4" />
            Reload the portal
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
